"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRejectOfferRequestDto = instanceOfRejectOfferRequestDto;
exports.RejectOfferRequestDtoFromJSON = RejectOfferRequestDtoFromJSON;
exports.RejectOfferRequestDtoFromJSONTyped = RejectOfferRequestDtoFromJSONTyped;
exports.RejectOfferRequestDtoToJSON = RejectOfferRequestDtoToJSON;
exports.RejectOfferRequestDtoToJSONTyped = RejectOfferRequestDtoToJSONTyped;
/**
 * Check if a given object implements the RejectOfferRequestDto interface.
 */
function instanceOfRejectOfferRequestDto(value) {
    if (!('rejectionReason' in value) || value['rejectionReason'] === undefined)
        return false;
    return true;
}
function RejectOfferRequestDtoFromJSON(json) {
    return RejectOfferRequestDtoFromJSONTyped(json, false);
}
function RejectOfferRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rejectionReason': json['rejectionReason'],
    };
}
function RejectOfferRequestDtoToJSON(json) {
    return RejectOfferRequestDtoToJSONTyped(json, false);
}
function RejectOfferRequestDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'rejectionReason': value['rejectionReason'],
    };
}
